<template>
  <div class="pi-root">
    <!-- ROW 1: info + ações -->
    <div class="pi-row">
      <!-- Info básica -->
      <div class="pi-card pi-card--main">
        <div class="pi-avatar">
          {{ cliente.nome ? cliente.nome[0].toUpperCase() : "?" }}
        </div>
        <div class="pi-info">
          <h2 class="pi-nome">{{ cliente.nome }}</h2>
          <div class="pi-detalhes">
            <span v-if="cliente.data_nascimento"
              >{{ calcularIdade(cliente.data_nascimento) }} anos</span
            >
            <span v-if="cliente.email">{{ cliente.email }}</span>
            <span v-if="cliente.telefone">{{ cliente.telefone }}</span>
          </div>
          <div class="pi-qr">
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="3" y="3" width="7" height="7" />
              <rect x="14" y="3" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" />
              <path
                d="M14 14h.01M17 14h.01M14 17h.01M17 17h.01M20 14h.01M20 17h.01M20 20h.01M17 20h.01M14 20h.01"
              />
            </svg>
            {{ cliente.qr_code }}
          </div>
        </div>
      </div>

      <!-- Última visita -->
      <div class="pi-card">
        <span class="pi-card-label">Última Visita</span>
        <span class="pi-card-val">{{ tempoDesde(cliente.ultima_visita) }}</span>
      </div>

      <!-- Cartão criado -->
      <div class="pi-card">
        <span class="pi-card-label">Cartão Criado</span>
        <span class="pi-card-val">{{ tempoDesde(cliente.dt_created) }}</span>
      </div>

      <!-- NIF -->
      <div class="pi-card pi-card--click" @click="$emit('editar-nif')">
        <span class="pi-card-label">NIF</span>
        <div class="pi-nif-row">
          <span class="pi-card-val">{{ cliente.nif || "—" }}</span>
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ff825d"
            stroke-width="2.2"
          >
            <path
              d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
        </div>
      </div>

      <!-- Envios -->
      <div class="pi-card">
        <span class="pi-card-label">Nº de Envios</span>
        <span class="pi-card-val">{{ cliente.total_envios || 0 }}</span>
      </div>

      <!-- Último envio -->
      <div class="pi-card">
        <span class="pi-card-label">Último Envio</span>
        <span class="pi-card-val">{{ tempoDesde(cliente.ultima_envio) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PerfilInfo",
    props: {
      cliente: { type: Object, required: true },
    },
    methods: {
      calcularIdade(dataNascimento) {
        if (!dataNascimento) return "–";
        const hoje = new Date(),
          nasc = new Date(dataNascimento);
        let idade = hoje.getFullYear() - nasc.getFullYear();
        if (
          hoje.getMonth() < nasc.getMonth() ||
          (hoje.getMonth() === nasc.getMonth() &&
            hoje.getDate() < nasc.getDate())
        )
          idade--;
        return isNaN(idade) ? "–" : idade;
      },
      tempoDesde(dataStr) {
        if (!dataStr || dataStr === "Nunca foi enviado") return dataStr || "—";
        const data = new Date(dataStr);
        if (isNaN(data)) return dataStr;
        const dias = Math.floor((Date.now() - data.getTime()) / 86400000);
        if (dias === 0) return "Hoje";
        if (dias === 1) return "Ontem";
        if (dias < 30) return `${dias} dias`;
        const meses = Math.floor(dias / 30);
        if (meses < 12) return `${meses} ${meses === 1 ? "mês" : "meses"}`;
        const anos = Math.floor(meses / 12);
        return `${anos} ${anos === 1 ? "ano" : "anos"}`;
      },
    },
  };
</script>

<style scoped>
  .pi-root {
    margin-bottom: 16px;
  }
  .pi-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }
  .pi-card {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 14px;
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    min-width: 130px;
  }
  .pi-card--main {
    flex-direction: row;
    align-items: center;
    gap: 14px;
    flex: 2;
    min-width: 260px;
  }
  .pi-card--click {
    cursor: pointer;
    transition: border-color 0.15s;
  }
  .pi-card--click:hover {
    border-color: #ff825d;
  }

  .pi-avatar {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: #ff825d;
    color: #fff;
    font-size: 22px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 14px rgba(255, 130, 93, 0.3);
  }
  .pi-info {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .pi-nome {
    font-size: 16px;
    font-weight: 800;
    color: #1a1210;
    margin: 0;
    letter-spacing: -0.3px;
  }
  .pi-detalhes {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .pi-detalhes span {
    font-size: 13px;
    color: #6b6460;
  }
  .pi-detalhes span + span::before {
    content: "·";
    margin-right: 8px;
    color: #d0c8c0;
  }
  .pi-qr {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    font-weight: 600;
    color: #b0a8a0;
    background: #f8f6f3;
    border-radius: 6px;
    padding: 3px 8px;
    width: fit-content;
  }

  .pi-card-label {
    font-size: 11px;
    font-weight: 700;
    color: #b0a8a0;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
  .pi-card-val {
    font-size: 22px;
    font-weight: 800;
    color: #1a1210;
    letter-spacing: -0.5px;
    line-height: 1.1;
  }
  .pi-nif-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  @media (max-width: 768px) {
    .pi-card {
      min-width: calc(50% - 6px);
    }
    .pi-card--main {
      min-width: 100%;
      flex: none;
    }
  }
</style>
